export default {
  login: {
    en: 'Login',
    sk: 'Prihlásiť sa',
    cz: 'Přihlásit se',
    de: 'Anmeldung',
  },
}
